import { useContext } from "react"
import { ThemeContext } from "../contexts/ThemeContext"
import SocialMediaData from "../data/socialMediaData.json"

/**
 * @component SocialMedia.
 * @returns {JSX.Element} - The SocialMedia component.
 */
export default function SocialMedia() {
    /**
     * Theme context.
     * @type {{object}}.
     */
    const { theme } = useContext(ThemeContext)

    /**
     * Social Media Data.
     * @type {object}.
     */
    const socialMedias = SocialMediaData.socialMedias

    return (
        <div className="social__media">
            {socialMedias.map((socialMedia) => (<SocialMediaIcon key={`social-media-${socialMedia.name}`} url={socialMedia.url} icon={socialMedia.icon} />))}
        </div>
    )

    function SocialMediaIcon({ url, icon }) {
        return (
            <a className={`social__media__icon color--${theme}--1 background--${theme}--2--hover`} href={url} target="_blank" rel="noreferrer">
                <i className={icon} />
            </a>
        )
    }
}